import React, { memo } from 'react'
import { Space } from 'antd'
import cls from './note-change-data-template.module.css'
import { classNames } from '../../../../../../../../lib/classNames/classNames'

interface NoteDefaultTemplateProps {
  className?: string
  text?: string
}

const NoteDefaultTemplate: React.FC<NoteDefaultTemplateProps> = memo(
  (props: NoteDefaultTemplateProps) => {
    const { className, text } = props
    const formattedText = text ? text.replace(/\n/g, '<br/>') : ''
    return (
      <Space className={classNames(cls.textWrapper, {}, [className])}>
        <span dangerouslySetInnerHTML={{ __html: formattedText }} />
      </Space>
    )
  },
)

NoteDefaultTemplate.displayName = 'NoteDefaultTemplate'
export default NoteDefaultTemplate
